import { __read } from "tslib";
import { UploadStatus } from '@office-start/upload-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
export function useUploadErrorDialog(uploadStatus, changeSetShowDialog, locStrings) {
    var _a = __read(useState(''), 2), dialogTitle = _a[0], setDialogTitle = _a[1];
    var _b = __read(useState(''), 2), dialogText = _b[0], setDialogText = _b[1];
    var setDialogProperties = useCallback(function (text, title) {
        setDialogText(text);
        setDialogTitle(title);
        changeSetShowDialog(true);
    }, [changeSetShowDialog]);
    useEffect(function () {
        if (locStrings) {
            switch (uploadStatus) {
                case UploadStatus.Unsupported: {
                    setDialogProperties(locStrings.edgeworthResources.uploadUnsupportedText, locStrings.edgeworthResources.uploadFailureTitle);
                    break;
                }
                case UploadStatus.Failed: {
                    setDialogProperties(locStrings.edgeworthResources.uploadFailureText, locStrings.edgeworthResources.uploadFailureTitle);
                    break;
                }
                case UploadStatus.Uploading: {
                    setDialogProperties(locStrings.edgeworthResources.uploadProgressText, locStrings.edgeworthResources.uploadProgressTitle);
                    break;
                }
                case UploadStatus.Completed: {
                    changeSetShowDialog(false);
                }
            }
        }
    }, [changeSetShowDialog, locStrings, setDialogProperties, uploadStatus]);
    return useMemo(function () { return ({
        dialogText: dialogText,
        dialogTitle: dialogTitle,
    }); }, [dialogText, dialogTitle]);
}
//# sourceMappingURL=useUploadErrorDialog.js.map